import { render } from "./CreatorHeaderSmallBox.vue?vue&type=template&id=3d8025c9"
import script from "./CreatorHeaderSmallBox.vue?vue&type=script&lang=js"
export * from "./CreatorHeaderSmallBox.vue?vue&type=script&lang=js"

import "./CreatorHeaderSmallBox.vue?vue&type=style&index=0&id=3d8025c9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__